export function extractFilename(url: string): string {
  try {
    const path = new URL(url).pathname;
    const raw = decodeURIComponent(path.split('/').pop() || 'document');
    return raw || 'document';
  } catch {
    const raw = decodeURIComponent(url.split('?')[0].split('/').pop() || 'document');
    return raw || 'document';
  }
}

export function getSasTimes(url: string): { st?: Date; se?: Date } {
  try {
    const q = url.split('?')[1];
    if (!q) return {};
    const params = new URLSearchParams(q);
    const st = params.get('st');
    const se = params.get('se');
    return { st: st ? new Date(st) : undefined, se: se ? new Date(se) : undefined };
  } catch {
    return {};
  }
}

export function sasNeedsRefresh(url: string): boolean {
  if (!url) return true;
  if (!url.includes('?sv=')) return true;

  const { st, se } = getSasTimes(url);
  const now = new Date();

  if (st && st > now) return true;
  if (se && se <= now) return true;
  return false;
}
